import { call, put, takeLatest } from 'redux-saga/effects';
import * as ActionTypes from './actions';
import Api from './api';
import { notifyError } from 'src/utils/notification';

function* getPolygonAreasSaga({ payload }: any) {
  try {
    const { data } = yield call(
      Api.fetchPolygons,
      payload.cameraId,
    );
    yield put(ActionTypes.getPolygonAreas.success(data));
  } catch (e) {
    notifyError(e as string);
    yield put(ActionTypes.getPolygonAreas.failure(e));
  }
}

function* getPolygonSaga({ payload }: any) {
  try {
    const { data } = yield call(Api.fetchPolygon, payload.areaId);
    yield put(ActionTypes.getPolygon.success(data));
  } catch (e) {
    notifyError(e as string);
    yield put(ActionTypes.getPolygon.failure(e));
  }
}

function* getAllPolygonMetricsSaga({ payload }: any) {
  try {
    const { data } = yield call(
      Api.fetchAllPolygonMetrics,
      payload.startDate,
      payload.endDate
    );
    yield put(ActionTypes.getAllPolygonMetrics.success(data.polygons_metrics));
  } catch (e) {
    notifyError(e as string);
    yield put(ActionTypes.getAllPolygonMetrics.failure(e));
  }
}

export default function* polygonsSaga(): Generator<any, void, any> {
  yield takeLatest(ActionTypes.GET_POLYGON_AREAS, getPolygonAreasSaga);
  yield takeLatest(ActionTypes.GET_POLYGON, getPolygonSaga);
  yield takeLatest(ActionTypes.GET_ALL_POLYGON_METRICS, getAllPolygonMetricsSaga);
} 
